// import { Component, OnInit } from '@angular/core';
// import { InvoiceService } from 'src/app/services/invoice/invoice.service';
// import { Route, Router, ActivatedRoute } from '@angular/router';
// import { FormGroup, FormBuilder } from '@angular/forms';
// import { Invoicetrackreq } from 'src/app/model/invoicetrackreq.model';
// import { formArrayNameProvider } from '@angular/forms/src/directives/reactive_directives/form_group_name';
// import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';

@Component({
  selector: 'app-paymentpage',
  templateUrl: './paymentpage.component.html',
  styleUrls: ['./paymentpage.component.css']
})
export class PaymentpageComponent implements OnInit {


  data: any;

  constructor(private invoiceServices: InvoiceService) { }

  ngOnInit() {
    this.getVendorPaidInvoiceList();
  }

  getVendorPaidInvoiceList() {
    this.invoiceServices.getVendorPaidInvoiceList().subscribe(
      (data: any) => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  // vendorInvoice: Invoicetrackreq;
  // InvoiceDocs: any;
  // vendorInvoiceData: any;
  // form: FormGroup;
  // stepno: any;
  // data: any
  // constructor(private invoiceservice: InvoiceService, private router: Router,
  //   private route: ActivatedRoute, private fb: FormBuilder) {

  // }

  // ngOnInit() {
  //   this.getInvoiceDocs();

  // }

  // getInvoiceDocs() {

  //   this.invoiceservice.GetInvoiceDocs().subscribe(
  //     (data: any) => {

  //       console.log("sdfkj");
  //       this.InvoiceDocs = data;
  //       console.log(this.InvoiceDocs);
  //     }
  //   );
  // }

  // getSelectedInvoiceLines(invoiceid)
  // {

  //   this.invoiceservice.getSelectedInvoiceLines(invoiceid).subscribe(
  //     (data : any) => {
  //       this.data = data;
  //       console.log(this.data);
  //     }
  //   )
  // }

  // invoicevendorsearch(keyword) {

  //   this.invoiceservice.InvoiceVendorSearch(keyword).subscribe(
  //     (data) => {

  //       console.log(data);
  //     }
  //   )

  // }


}
